import { Capacitor } from '@capacitor/core'

function useIsMobileCapacitor() {
  return Capacitor.isNativePlatform() || window._env_?.CAPACITOR_DEBUG
}

export default useIsMobileCapacitor
